module.exports = __webpack_public_path__ + "87a9df1ad42a49c32ba7a4ee05ccf9e1.pdf";